import { Actions } from '../../interfaces'

import { SaleProduct } from '@/entities/sales'
import create from './create'
import fetch from './fetch'
import update from './update'
import find from './find'

export const actions: Actions = {
  create,
  fetch,
  update,
  find,
}

export default {
  Model: { SaleProduct },
  actions: { [SaleProduct.name]: actions },
}
